module.exports = __webpack_public_path__ + "img/iu_logo.65bc7e8a.svg";